export const downloadFile = async (fileId, format = 'xlsx') => {
    try {
        const fullUrl = `https://www.copia.guru/api/download/${fileId}?format=${format}`;
        const response = await fetch(fullUrl);

        if (!response.ok) {
            let errorMessage = `Download failed with status: ${response.status}`;
            try {
                const errorData = await response.json();
                errorMessage = errorData.message || errorMessage;
            } catch (e) {
                // Response body was not JSON
            }
            throw new Error(errorMessage);
        }

        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = `copia_data.${format}`;

        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/);
            if (filenameMatch) {
                filename = filenameMatch[1];
            }
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.style.display = 'none';
        anchor.href = url;
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(anchor);

        return { success: true, message: `File downloaded successfully as ${filename}` };
    } catch (error) {
        console.error('Download error:', error);
        return { success: false, message: error.message || 'Failed to download file. Please try again.' };
    }
};

export const previewFile = async (fileId) => {
    try {
        const response = await fetch(`https://www.copia.guru/api/download/${fileId}/preview`);

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Preview failed');
        }

        const data = await response.json();
        return { success: true, message: 'Preview generated successfully', data };
    } catch (error) {
        console.error('Preview error:', error);
        return { success: false, message: error.message || 'Failed to generate preview' };
    }
};

export const createDownloadStatusMessage = (recordCount, format = 'xlsx') => {
    return `Downloaded ${recordCount} records as ${format.toUpperCase()}`;
};

// Expose download handler globally for inline buttons in rendered HTML
window.handleDownload = async (fileId, format = 'xlsx') => {
    const result = await downloadFile(fileId, format);
    return result.success;
};
